import Utils from '@/ecm/common/Utils';
export default class ContentTypeRight {
    constructor (dto) {
        this.uuid = Utils.object.getUUID();
        this.id = 0;
        this.roleTypeID = '';
        this.accessRightId = '';
        this.digitalSignatureConfigId = '';
        this.conditionStr = '';
        this.displayConditionStr = '';

        if (dto) {
            this.id = dto.id;
            this.roleTypeID = dto.roleTypeID + '';
            this.accessRightId = dto.accessRightId + '';
            this.digitalSignatureConfigId = dto.digitalSignatureConfigId + '';
            this.conditionStr = dto.conditionStr;
            this.displayConditionStr = dto.displayConditionStr;
        }
    }

    toDto () {
        return {
            Id: this.id,
            RoleTypeID: this.roleTypeID,
            AccessRightId: this.accessRightId,
            DigitalSignatureConfigId: this.digitalSignatureConfigId,
            ConditionStr: this.conditionStr,
        };
    }
}
